import { formGoReportFields } from '../constants/forms/formGoReport';
import { MonthRangeField, MonthYearField } from '../atoms';
import { Col, Radio, Row } from 'antd';
import RffFields from '../atoms/rff/RffFields';

export const parseNumber = (value) =>
  value && value.toString().replace(/\D/g, '');

export const parseFloatWithPrecision =
  (precision, negativeAllowed = false) =>
  (value) => {
    const normalized = value.replace(',', '.');
    const replaceRegex = negativeAllowed ? /[^0-9.-]/g : /[^0-9.]/g;
    let replaced = normalized.replace(replaceRegex, '');
    if (negativeAllowed && replaced.startsWith('-')) {
      replaced = '-' + replaced.replaceAll('-', '');
    }
    const splitArr = replaced.split('.');
    if (splitArr.length > 1)
      return `${splitArr[0]}.${splitArr[1].slice(0, precision)}`;
    return replaced;
  };

export const parseMegawatt = parseFloatWithPrecision(3);

export const parseCharAndSpace = (value) => value.replace(/\d/g, '');

export const filterFieldRenderer = ({ t, monthFilter }) => {
  if (monthFilter) {
    return (
      <RffFields
        names={[formGoReportFields.MONTH, formGoReportFields.YEAR]}
        className="date-field"
        component={MonthYearField}
        hasFeedback={false}
      />
    );
  }

  return (
    <RffFields
      names={[formGoReportFields.DATE_FROM, formGoReportFields.DATE_TO]}
      placeholder={[
        t('goReport.dateRange.dateFromPlaceholder'),
        t('goReport.dateRange.dateToPlaceholder'),
      ]}
      component={MonthRangeField}
      hasFeedback={false}
    />
  );
};

export const getFilteredFormParams = (formValues, monthFilter) => {
  if (!formValues) return {};

  // Support both Immutable.js (redux-form) and plain objects (react-final-form)
  const values = formValues.toJS ? formValues.toJS() : formValues;
  const rawParams = Object.entries(values).reduce(
    (acc, [key, value]) => (value ? { ...acc, [key]: value } : acc),
    {}
  );

  if (monthFilter) {
    delete rawParams[formGoReportFields.DATE_FROM];
    delete rawParams[formGoReportFields.DATE_TO];
  } else {
    delete rawParams[formGoReportFields.MONTH];
    delete rawParams[formGoReportFields.YEAR];
  }

  return rawParams;
};

export const renderFilterRows = ({
  monthFilter,
  t,
  onChange,
  monthLabelKey,
  rangeLabelKey,
  secondRowContent,
}) => (
  <>
    <Row gutter={32}>
      <Col span={8}>
        <Radio.Group
          name="filterModeGroup"
          value={monthFilter}
          onChange={onChange}
        >
          <Radio value>{t(monthLabelKey)}</Radio>
          <Radio value={false}>{t(rangeLabelKey)}</Radio>
        </Radio.Group>
      </Col>
    </Row>
    <Row gutter={32}>
      <Col span={8}>{secondRowContent}</Col>
    </Row>
  </>
);
